function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("title", null, "burger");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "burger",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M52,17 L2,17 C0.8954305,17 0,17.8954305 0,19 C0,20.1045695 0.8954305,21 2,21 L52,21 C53.1045695,21 54,20.1045695 54,19 C54,17.8954305 53.1045695,17 52,17 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52,33.83 L2,33.83 C0.8954305,33.83 0,34.7254305 0,35.83 C0,36.9345695 0.8954305,37.83 2,37.83 L52,37.83 C53.1045695,37.83 54,36.9345695 54,35.83 C54,34.7254305 53.1045695,33.83 52,33.83 Z",
  id: "Path"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2,4.17 L52,4.17 C53.1045695,4.17 54,3.2745695 54,2.17 C54,1.0654305 53.1045695,0.17 52,0.17 L2,0.17 C0.8954305,0.17 0,1.0654305 0,2.17 C0,3.2745695 0.8954305,4.17 2,4.17 Z",
  id: "Path"
})));
const SvgBurgerMenu = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "54px",
    height: "38px",
    viewBox: "0 0 54 38",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBurgerMenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/burger-menu.c96ff7ff.svg";
export { ForwardRef as ReactComponent };